import React, { useState, forwardRef } from 'react'
import {
    IconPlayFilled,
    IconPause,
    IconSpeakerOn,
    IconSpeakerOff,
    IconReset,
    IconFitToExtend,
    IconFitToScreenSize,
    IconVideoNextFrame,
    IconVideoPreviousFrame,
} from 'components/Zui/Icon'
import { InteractiveIcon } from 'components/Zui'
import { secondsToHMS } from 'utils/datetime'
import './Custom.css'

function CustomSlider(props, ref) {
    const {
        played,
        playing,
        muted,
        volume,
        ended,
        buffering,
        playbackRate,
        duration,
        bookmarks,
        onPlayPause,
        onMute,
        onHandlePlay,
        onRewindFrame,
        onForwardFrame,
        onVolumeChange,
        onVolumeSeekUp,
        onPlaybackChange,
        onBookmarkNext,
        onBookmarkPrev,
        onBookmarkClick,
        onSeek,
        onSeekMouseDown,
        onSeekMouseUp,
        isFullscreen,
        onToggleFullscreen,
    } = props
    const [seeking, setSeeking] = useState(false)

    return (
        <div ref={ref} className={`slider-wrap ${isFullscreen ? 'fullscreen-player-footer' : ''}`}>
            {/* <div className="player-top-controls"></div>
            <div className="player-middle-controls"></div> */}
            <div className="seekbar">
                {/* <div className="bookmark-container"> */}
                {/* {bookmarks.map(mark => (
                        <span
                            key={mark}
                            className="bookmark-icon"
                            style={{ left: `calc(${mark}% )` }}
                            onClick={() => onBookmarkClick(mark, true)}
                        >
                            <InteractiveIcon theme="zbds-dark">
                                <ZuiIconImage />
                            </InteractiveIcon>
                        </span>
                    ))} */}
                {/* </div> */}
                <div className="player-slider-wrapper">
                    <div className="played-time player-time">{secondsToHMS(duration * played)}</div>
                    <div className="slider-container">
                        <input
                            id="player-seekbar"
                            type="range"
                            name="player-seekbar"
                            min={0}
                            max={100}
                            step={0.01}
                            value={played * 100}
                            onChange={e => {
                                onSeek(e, e.target.value)
                            }}
                            onMouseDown={() => {
                                setSeeking(true)
                                onSeekMouseDown()
                            }}
                            onMouseUp={e => {
                                setSeeking(false)
                                onSeekMouseUp(e, e.target.value)
                            }}
                            style={{
                                background: `linear-gradient(90deg,rgba(46, 122, 245,1) ${
                                    played * 100
                                }%, rgba(255, 255, 255, 0.1) 0)`,
                                height: '4px',
                            }}
                            onTouchStart={() => {
                                setSeeking(true)
                                onSeekMouseDown()
                            }}
                            onTouchEnd={e => {
                                setSeeking(false)
                                onSeekMouseUp(e, e.target.value)
                            }}
                        />
                        {/* {bookmarks.map(mark => (
                            <span
                                key={mark}
                                style={{ left: `${mark}%` }}
                                className="marker-dot"
                                onClick={() => onBookmarkClick(mark)}
                            ></span>
                        ))} */}
                        {seeking && (
                            <span className="slider-tooltip" style={{ left: `${played * 100}%` }}>
                                {secondsToHMS(duration * played)}
                            </span>
                        )}
                    </div>
                    <div className="total-time player-time"> {secondsToHMS(duration)}</div>
                </div>
                {/* player controls */}
                <div className="player-controls">
                    <div className="player-controls-wrapper">
                        <div className="left-controls">
                            <div className="volume-control-wrapper">
                                <div className="volume-icon-wrapper">
                                    <InteractiveIcon theme="zbds-dark" onClick={onMute}>
                                        {muted ? (
                                            <IconSpeakerOff size="m" />
                                        ) : (
                                            <IconSpeakerOn size="m" />
                                        )}
                                    </InteractiveIcon>
                                </div>

                                <input
                                    id="player-volume-seekbar"
                                    type="range"
                                    name="player-seekbar"
                                    value={volume * 100}
                                    min={0}
                                    max={100}
                                    onChange={e => {
                                        onVolumeSeekUp(e, e.target.value)
                                    }}
                                    onTouchEnd={e => {
                                        onVolumeSeekUp(e, e.target.value)
                                    }}
                                    style={{
                                        background: `linear-gradient(90deg,rgba(46, 122, 245,1) ${
                                            volume * 100
                                        }%,rgba(255, 255, 255, 0.1) 0)`,
                                        height: '4px',
                                    }}
                                />
                            </div>
                        </div>
                        <div className="middle-controls">
                            <InteractiveIcon theme="zbds-dark">
                                <IconVideoPreviousFrame size="s" onClick={onRewindFrame} />
                            </InteractiveIcon>
                            {!playing && !ended && (
                                <InteractiveIcon
                                    theme="zbds-dark"
                                    onClick={onPlayPause}
                                    disabled={buffering}
                                    style={{ minWidth: '24px' }}
                                >
                                    <IconPlayFilled size="l" />
                                </InteractiveIcon>
                            )}
                            {playing && (
                                <InteractiveIcon
                                    theme="zbds-dark"
                                    onClick={onPlayPause}
                                    style={{ minWidth: '24px' }}
                                >
                                    <IconPause size="l" />
                                </InteractiveIcon>
                            )}
                            {ended && (
                                <InteractiveIcon theme="zbds-dark" onClick={onHandlePlay}>
                                    <IconReset size="l" />
                                </InteractiveIcon>
                            )}
                            {/* </div> */}

                            <InteractiveIcon theme="zbds-dark">
                                <IconVideoNextFrame size="s" onClick={onForwardFrame} />
                            </InteractiveIcon>
                        </div>
                        <div className="right-controls">
                            <InteractiveIcon
                                theme="zbds-dark"
                                className="zui-icon-wrapper"
                                onClick={onToggleFullscreen}
                            >
                                {isFullscreen ? <IconFitToScreenSize /> : <IconFitToExtend />}
                            </InteractiveIcon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default forwardRef(CustomSlider)
